import { ApplicationType } from 'features/Onboarding/types';

const getShouldSendInvitations = (data: {
  applicationType: ApplicationType;
}) => {
  return data.applicationType === ApplicationType.CapitalDeposit;
};

export default getShouldSendInvitations;
